import { render } from "./SettingsButton.vue?vue&type=template&id=4f43581a&scoped=true&ts=true"
import script from "./SettingsButton.vue?vue&type=script&lang=ts"
export * from "./SettingsButton.vue?vue&type=script&lang=ts"

import "./SettingsButton.vue?vue&type=style&index=0&id=4f43581a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f43581a"],['__file',"src/components/list-items/SettingsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f43581a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f43581a', __exports__)) {
    api.reload('4f43581a', __exports__)
  }
  
  module.hot.accept("./SettingsButton.vue?vue&type=template&id=4f43581a&scoped=true&ts=true", () => {
    api.rerender('4f43581a', render)
  })

}


export default __exports__